var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEmulated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-emulator-toggle-no") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-emulator-toggle-no",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,7.857 L4.687,9.209 L4.6875,17.875 C4.6875,18.1843746 4.93921888,18.4375 5.25,18.4375 L16.198,18.437 L18.303,20.125 L5.25,20.125 C4.00722635,20.125 3,19.1160152 3,17.875 L3,7.857 Z M18.75,4.375 C19.9910152,4.375 21,5.38222635 21,6.625 L21,17.875 C21,18.5373672 20.7125726,19.1336365 20.2558481,19.5456775 L18.8602206,18.4265833 C19.1172981,18.3749839 19.3125,18.1466807 19.3125,17.875 L19.3125,6.625 C19.3125,6.31421888 19.0593746,6.0625 18.75,6.0625 L5.25,6.0625 C4.93921888,6.0625 4.6875,6.31421888 4.6875,6.625 L4.687,7.065 L3.14479229,5.82907745 C3.46621593,4.97920027 4.28745962,4.375 5.25,4.375 L18.75,4.375 Z M11.988,15.062 L14.093,16.75 L11.71875,16.75 C11.2511718,16.75 10.875,16.3738277 10.875,15.90625 C10.875,15.4386723 11.2511718,15.0625 11.71875,15.0625 L11.988,15.062 Z M16.78125,15.0625 C17.2488277,15.0625 17.625,15.4386723 17.625,15.90625 C17.625,16.3738277 17.2488277,16.75 16.78125,16.75 L16.769,16.75 L14.663,15.062 L16.78125,15.0625 Z M8.941,12.62 L10.273,13.688 L7.78828114,15.9660161 C7.44374979,16.2789065 6.9128902,16.2261721 6.59648395,15.9132817 C6.28183508,15.5687498 6.30503833,15.0378902 6.64921832,14.7214839 L8.941,12.62 Z M7.78828114,8.53398395 L11.1632811,11.6277345 C11.3390624,11.7894529 11.4375,12.0144532 11.4375,12.25 C11.4375,12.3195622 11.4289148,12.3882045 11.4122876,12.4545687 L6.59213555,8.59151543 C6.9128902,8.2421875 7.44374979,8.22109354 7.78828114,8.53398395 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEmulated);
export default __webpack_public_path__ + "static/media/no-emulated.3bac73585e1ce201b04062d3d85af22a.svg";
export { ForwardRef as ReactComponent };